import i18n from "i18next";
import { useApp } from "../context/AppContext";

// Hook to get the translated text
export const getTenantText = (key) => {
    const { settings } = useApp();
    const { translations } = settings;
    const currentLang = i18n.language.substring(0, 2) || "en"; // Default to 'en' if no language is set

    return translations[currentLang][key]
};
